import {decorate, observable, action} from 'mobx';
import TimeoutPopup from '../components/TimeoutPopup/TimeoutPopup';
import React from 'react';

export default class DisplayStore {

  constructor(rootStore) {
    this.rootStore = rootStore;
  }
  showHotelList = observable.box(false);
  userFullName = observable.box('');
  errorLoadingCode = observable.box(false);
  isLoading = observable.box(false);
  showPopup = observable.box(false);
  innerPopup = <TimeoutPopup />;

  locale = "de-DE";
  longDateFormat = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'europe/berlin' };
  shortDateFormat = { weekday: 'short', month: 'numeric', day: 'numeric', timeZone: 'europe/berlin' };
  timeFormat = {hour: '2-digit', minute:'2-digit', timeZone: 'europe/berlin' };
  rootStore = undefined;

  getShortDate(date) {
    return date.toLocaleDateString(this.locale, this.shortDateFormat);
  }
  getLongDate(date) {
    return date.toLocaleDateString(this.locale, this.longDateFormat);
  }

  getTime(date) {
    return date.toLocaleTimeString(this.locale, this.timeFormat);
  }


  setInnerPopup(innerPopup){
    this.innerPopup = innerPopup;
  }

  getPopup(){
    return this.showPopup.get();
  }

  setPopup(show){
    this.showPopup.set(show);
  }

  clearHotelList(){
    this.showHotelList.set(false);
    this.rootStore.hotelStore.setHotels({offers:[]});
  }
}
decorate(DisplayStore, {
  showHotelList: observable,
  userFullName: observable,
  errorLoadingCode: observable,
  isLoading: observable,
  showPopup: observable,
  innerPopup: observable,
  locale: observable,
  setInnerPopup: action,
  setPopup: action,
  clearHotelList: action
})